import { Fragment, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import SliderArrow from "./components/SliderArrow";
import SliderNote from "./components/SliderNote";
import "./slider.css";

const Slider = props => {
  const [state, setState] = useState({
    barCode: "",
    orderId: "",
    idxSlider: 0,
  });

  return (
    <Fragment>
      <div className="sliderStyle d-none d-md-block">
        <Carousel
          className="firstIndex"
          renderArrowPrev={clickHandler =>
            props.images.length > 1 ? (
              <SliderArrow clickHandler={clickHandler} position="left" />
            ) : (
              <Fragment></Fragment>
            )
          }
          renderArrowNext={clickHandler =>
            props.images.length > 1 ? (
              <SliderArrow clickHandler={clickHandler} position="right" />
            ) : (
              <Fragment></Fragment>
            )
          }
          showThumbs={false}
          showStatus={false}
          interval={6000}
          autoPlay={true}
          stopOnHover={true}
          showIndicators={false}
          dynamicHeight={true}
          infiniteLoop={true}
          onChange={idx => setState(cur => ({ ...cur, idxSlider: idx }))}
        >
          {props.images.map((image, idx) => (
            <div
              key={idx}
              className={
                "position-relative " +
                (image.title || image.body ? "slider-overlay " : "") +
                (image.textPosition === 1
                  ? "slider-overlay-right"
                  : "slider-overlay-left")
              }
            >
              <SliderNote
                selected={idx === state.idxSlider}
                position={image.textPosition}
                text={{ title: image.title, body: image.body }}
              />
              <img src={image.image} className="slider-image" />
            </div>
          ))}
        </Carousel>
      </div>
    </Fragment>
  );
};

export default Slider;
